// DOG1 Newsletter Submit Handler (Cluster P4.1)
// Submitted an die Klaviyo Legacy-Subscribe-API (form-encoded POST,
// JSON-Response). Inline-Status-Update, kein Klaviyo-Script-Load.
//
// Konfig kommt per data-* von der <section class="dog1-newsletter">,
// Form ist via [data-newsletter-form] markiert.

(function () {
  'use strict';

  var KLAVIYO_ENDPOINT = 'https://manage.kmail-lists.com/ajax/subscriptions/subscribe';

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-newsletter-form]').forEach(initNewsletterForm);
  });

  function initNewsletterForm(form) {
    var section = form.closest('.dog1-newsletter');
    var statusEl = form.querySelector('[data-newsletter-status]');
    var submitBtn = form.querySelector('button[type="submit"]');
    var emailInput = form.querySelector('input[type="email"]');

    if (!section || !statusEl || !submitBtn || !emailInput) {
      console.warn('Newsletter-Form: required elements missing');
      return;
    }

    var publicKey = section.dataset.klaviyoPublicKey;
    var listId = section.dataset.klaviyoListId;
    var successMsg = section.dataset.successMessage;
    var errorMsg = section.dataset.errorMessage;
    var alreadyMsg = section.dataset.alreadySubscribedMessage;

    if (!publicKey || !listId) {
      console.warn('Newsletter: Klaviyo public_key or list_id missing');
      return;
    }

    form.addEventListener('submit', function (event) {
      event.preventDefault();

      // HTML5-Validation via JS triggern (Form hat novalidate)
      if (!emailInput.checkValidity()) {
        emailInput.reportValidity();
        return;
      }

      // Loading-State
      form.classList.add('dog1-form--loading');
      submitBtn.setAttribute('aria-busy', 'true');
      submitBtn.disabled = true;
      statusEl.textContent = '';
      statusEl.classList.remove('dog1-newsletter__status--error', 'dog1-newsletter__status--success');

      // 'a' (Public-Key) ist Pflicht — ohne ihn nimmt Klaviyo den Submit
      // mit Status 200 an, schreibt aber kein Profil in die Liste.
      var body = new URLSearchParams();
      body.append('a', publicKey);
      body.append('g', listId);
      body.append('email', emailInput.value);
      body.append('$source', 'dog1-newsletter-section');

      fetch(KLAVIYO_ENDPOINT, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          Accept: 'application/json'
        },
        body: body.toString(),
        mode: 'cors'
      })
        .then(function (response) {
          return response.json();
        })
        .then(function (data) {
          if (data.success || (data.data && data.data.is_subscribed)) {
            form.classList.add('dog1-newsletter__form--submitted');
            statusEl.classList.add('dog1-newsletter__status--success');
            statusEl.textContent = successMsg;
            emailInput.value = '';
          } else if (data.errors && data.errors.some(function (e) {
            return /already|exists|subscribed/i.test(e);
          })) {
            statusEl.classList.add('dog1-newsletter__status--success');
            statusEl.textContent = alreadyMsg;
          } else {
            statusEl.classList.add('dog1-newsletter__status--error');
            statusEl.textContent = errorMsg;
          }
        })
        .catch(function (error) {
          console.error('Newsletter submit error:', error);
          statusEl.classList.add('dog1-newsletter__status--error');
          statusEl.textContent = errorMsg;
        })
        .finally(function () {
          form.classList.remove('dog1-form--loading');
          submitBtn.removeAttribute('aria-busy');
          submitBtn.disabled = false;
          // Screenreader auf das Feedback lenken
          if (statusEl.textContent) {
            statusEl.setAttribute('tabindex', '-1');
            statusEl.focus();
          }
        });
    });
  }
})();
